export const PRIORITY_THREE = 3;
export const PRIORITY_TWO = 2;
export const PRIORITY_ONE = 1;